import { booleanRegexOptions } from 'src/shared/constants/regex-formats/booleanRegex.constant';
import { currencyRegexOptions } from 'src/shared/constants/regex-formats/currencyRegex';
import { dateRegexOptions } from 'src/shared/constants/regex-formats/dateRegex.constant';
import { numberRegexOptions } from 'src/shared/constants/regex-formats/numberRegex.constant';
import { textRegexOptions } from 'src/shared/constants/regex-formats/textRegex.constant';
import { RegexOption } from 'src/shared/constants/regex-formats/types/RegexTypes';

// Re-export for backwards compatibility
export type { RegexOption };

// The keys must be readable and unique
export function getRegexOptions(): Record<string, RegexOption[]> {
  const regexOptions: Record<string, RegexOption[]> = {
    Text: textRegexOptions,
    Date: dateRegexOptions,
    Number: numberRegexOptions,
    Boolean: booleanRegexOptions,
    Currency: currencyRegexOptions,
  };

  return regexOptions;
}
